import React from 'react'
import MultipleLocations from './MultipleLocations'
import LocationCTA from './LocationCTA'
import LocationBanner from './LocationBanner'
import DynamicBreadcrumb from '../../components/DynamicBreadcrumb'

export default function Locations() {
  const breadcrumbData = [
    {
      page: "Home",
      slug: "/",
    },
    {
      page: "Our Locations",
      slug: "",
    }
  ]

  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <LocationBanner />
      <MultipleLocations />
      <LocationCTA />
    </>
  )
}


